export const VALIDATE_TIN = 'postRegistration/VALIDATE_TIN';
export const UPDATE_TIN = 'postRegistration/UPDATE_TIN';
